import React, { useState, useEffect } from 'react';
import { apiService } from '../services/api';

const UnknownNetworks: React.FC = () => {
  const [unknownNetworks, setUnknownNetworks] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUnknownNetworks();
  }, []);

  const fetchUnknownNetworks = async () => {
    try {
      setLoading(true);
      const response = await apiService.getUnknownNetworks();
      setUnknownNetworks(response.items || []);
    } catch (error) {
      console.error('Error fetching unknown networks:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleResolve = async (id: number) => {
    try {
      await apiService.resolveUnknownNetwork(id);
      fetchUnknownNetworks();
    } catch (error) {
      console.error('Error resolving unknown network:', error);
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900">Unknown Networks</h1>
      <p className="mt-2 text-sm text-gray-700">
        Networks that were queried but not found in the database.
      </p>

      <div className="mt-6 flex flex-col">
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Queried Value
                    </th>
                    <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Type
                    </th>
                    <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      First Seen
                    </th>
                    <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Last Seen
                    </th>
                    <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Hit Count
                    </th>
                    <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Status
                    </th>
                    <th className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                      <span className="sr-only">Actions</span>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {loading ? (
                    <tr>
                      <td colSpan={7} className="text-center py-4">
                        Loading...
                      </td>
                    </tr>
                  ) : unknownNetworks.length === 0 ? (
                    <tr>
                      <td colSpan={7} className="text-center py-4">
                        No unknown networks found
                      </td>
                    </tr>
                  ) : (
                    unknownNetworks.map((network) => (
                      <tr key={network.id}>
                        <td className="whitespace-nowrap px-3 py-4 text-sm font-medium text-gray-900">
                          {network.queried_value}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          {network.request_type}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          {new Date(network.first_seen).toLocaleDateString()}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          {new Date(network.last_seen).toLocaleDateString()}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          {network.hit_count}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm">
                          <span
                            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                              network.resolved
                                ? 'bg-green-100 text-green-800'
                                : 'bg-yellow-100 text-yellow-800'
                            }`}
                          >
                            {network.resolved ? 'Resolved' : 'Pending'}
                          </span>
                        </td>
                        <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                          {!network.resolved && (
                            <button
                              onClick={() => handleResolve(network.id)}
                              className="text-indigo-600 hover:text-indigo-900"
                            >
                              Resolve
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnknownNetworks;